import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {FingerDetectionMode} from '@identy/identy-finger';

@Injectable({
  providedIn: 'root'
})
export class MissingFingerService {
  constructor() {
    this._fingers = [];
    this._fingerSelection = new Subject();
    this.bind();
  }

  private _fingers: FingerDetectionMode[];

  get fingers(): FingerDetectionMode[] {
    return this._fingers;
  }

  private _fingerSelection: Subject<FingerDetectionMode[]>;

  get fingerSelection(): Subject<Array<FingerDetectionMode>> {
    return this._fingerSelection;
  }

  bind() {
    this._fingerSelection.subscribe((fingers: FingerDetectionMode[]) => {

      this._fingers = fingers;

    });
  }

}
